import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  Container,
  Paper,
} from '@mui/material';
import TopNavBar from '../../Components/TopNavigation/TopNavBar';
import { request } from '../../Utils/request';
import { RootState } from '../../store/rootReducers';
import { useSelector, useDispatch } from 'react-redux';
import { setPostsReelsByLocation } from '../../store/slices/AccountPrivacySlice';

interface ApiResponse {
  success?: boolean;
  data?: any;
  message?: string;
}

const AccountPrivacy: React.FC = () => {
  const dispatch = useDispatch();
  const [isPrivateAccount, setIsPrivateAccount] = useState(false);
  const postsReelsByLocation = useSelector(
    (state: RootState) => state.accountPrivacy.postsReelsByLocation
  );
  const currentUser = useSelector((state: RootState) => state.user.user);

  const handlePrivateAccountToggle =async (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsPrivateAccount(event.target.checked);
    const id = currentUser.id || currentUser._id
    const profileData ={type:event.target.checked ? 'private':'public'}
    const response = await request<ApiResponse>(`/profile/${id}`, {
      method: 'PUT',
      body: profileData,
      authorization: true,
    });
    
  };

  const handleLocationToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    dispatch(setPostsReelsByLocation(checked));
    // TODO: persist to API when backend supports posts/reels by location setting
  };

  useEffect(()=>{
    if(currentUser.type === "public"){
      setIsPrivateAccount(false)
    }else{
      setIsPrivateAccount(true)

    }

  },[])
  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column'
    }}>
      <TopNavBar title="Account privacy" canGoBack />
      
      <Container maxWidth="sm" sx={{ flex: 1, py: 2 }}>
        <Box 
          sx={{ 
            p: 3,
          }}
        >
          {/* Private Account Toggle */}
          <Box sx={{ mb: 3 }}>
            <FormControlLabel
               label={
                 <Typography 
                   variant="body1" 
                   sx={{ 
                     fontWeight: 500,
                     color: '#49454F',
                     ml: 1
                   }}
                 >
                   Private account
                 </Typography>
               }
               control={
                 <Switch
                 size='medium'
                   checked={isPrivateAccount}
                   onChange={handlePrivateAccountToggle}
                   sx={{
                     '& .MuiSwitch-switchBase.Mui-checked': {
                       color: '#008387',
                       '& + .MuiSwitch-track': {
                         backgroundColor: '#008387',
                       },
                     },
                     '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                       backgroundColor: '#008387',
                     },
                   }}
                 />
               }
               sx={{ 
                 alignItems: 'center',
                 m: 0,
                 width: '100%',
                 justifyContent: 'space-between',
                 flexDirection: 'row-reverse'
               }}
            />
            <FormControlLabel
               label={
                 <Typography 
                   variant="body1" 
                   sx={{ 
                     fontWeight: 500,
                     color: '#49454F',
                     ml: 1
                   }}
                 >
                  Posts & Reels by Location
                 </Typography>
               }
               control={
                 <Switch
                 size='medium'
                   checked={postsReelsByLocation}
                   onChange={handleLocationToggle}
                   sx={{
                     '& .MuiSwitch-switchBase.Mui-checked': {
                       color: '#008387',
                       '& + .MuiSwitch-track': {
                         backgroundColor: '#008387',
                       },
                     },
                     '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                       backgroundColor: '#008387',
                     },
                   }}
                 />
               }
               sx={{ 
                 alignItems: 'center',
                 m: 0,
                 width: '100%',
                 justifyContent: 'space-between',
                 flexDirection: 'row-reverse'
               }}
            />
          </Box>

      
        </Box>
      </Container>
    </Box>
  );
};

export default AccountPrivacy;
